import React from 'react';
import { DrawerContent, useColorModeValue } from '@chakra-ui/react';

/** Ancho máximo de drawers de edición (grandes pero no pantalla completa). */
export const ADMIN_DRAWER_MAX_W = {
  base: '100%',
  sm: 'min(96vw, 920px)',
  md: 'min(92vw, 960px)',
  xl: 'min(88vw, 1040px)',
};

/** Drawer del calendario de agenda: más ancho para formularios de servicio. */
export const SCHEDULER_DRAWER_MAX_W = {
  base: '100%',
  sm: 'min(98vw, 960px)',
  md: 'min(94vw, 1100px)',
  xl: 'min(90vw, 1180px)',
};

/** Formularios CRUD (cliente, producto, etc.): panel lateral compacto. */
export const ADMIN_FORM_DRAWER_MAX_W = {
  base: '100%',
  sm: 'min(96vw, 640px)',
  md: 'min(92vw, 720px)',
  xl: '720px',
};

/**
 * Contenido de drawer lateral con ancho acotado.
 */
const AdminDrawerContent = ({ children, variant = 'default', ...rest }) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const maxW =
    variant === 'scheduler'
      ? SCHEDULER_DRAWER_MAX_W
      : variant === 'form'
        ? ADMIN_FORM_DRAWER_MAX_W
        : ADMIN_DRAWER_MAX_W;

  return (
    <DrawerContent
      maxW={maxW}
      w="100%"
      borderLeftWidth="1px"
      borderColor={borderColor}
      {...rest}
    >
      {children}
    </DrawerContent>
  );
};

export default AdminDrawerContent;
